var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('synthesis-risk-summary-block')],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('synthesis-risk-methods-block')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }